import { useEffect, useState } from 'react'
import { bbaiCYOAPromptOptions, bbaiCYOAPromptStepStatus, bbaiUser, defaultUser } from '../../../constants/bbai.prompts'
import PromptMessage from './PromptMessage'
import useNewCYOAStore from '../../../newCYOAStore'
import LoginPrompt from './LoginPrompt'
import { BBPlatformClient } from '../../../api/BBPlatform'
import ErrorOutOfCreditsCYOA from './ErrorOutOfCreditsCYOA'

const InitialCYOAPrompt = (): JSX.Element => {
  // const bbaiStore = state'
  const [userStoryPrompt, setUserStoryPrompt] = useState<string>("")
  const [notEnoughCreditsError, setNotEnoughCreditsError] = useState<boolean>(false)

  const bbaiStore = useNewCYOAStore()

  useEffect(() => {
    if(bbaiStore.userStoryPrompt.length > 0){
      setUserStoryPrompt(bbaiStore.userStoryPrompt)
      if(bbaiStore.isAuthed){
        CheckIfUserHasEnoughCredits()
      }
    }
    // eslint-disable-next-line
  }, [bbaiStore.userStoryPrompt, bbaiStore.isAuthed, notEnoughCreditsError])

  const CheckIfUserHasEnoughCredits = async() => {
    const userCreditsInfo = await BBPlatformClient.getBalance()

    if (userCreditsInfo.balance < 1) {
      setNotEnoughCreditsError(true)
      bbaiStore.setPromptStepState(bbaiCYOAPromptStepStatus.ERROR_RESTART_REGENERATE)  
    }

    bbaiStore.nextStage()
  }

  return (
    <>
    <PromptMessage promptStage={bbaiCYOAPromptStepStatus.INITIAL} message={bbaiCYOAPromptOptions.INITIAL.prompt} user={bbaiUser}
    />

    { userStoryPrompt.length > 0 && <PromptMessage promptStage={bbaiCYOAPromptStepStatus.INITIAL} message={userStoryPrompt} user={defaultUser}
      />
    }
    {notEnoughCreditsError && <ErrorOutOfCreditsCYOA/> }

    { userStoryPrompt.length > 0 && !bbaiStore.isAuthed && <PromptMessage promptStage={bbaiCYOAPromptStepStatus.INITIAL} component={<LoginPrompt />} message={""} user={bbaiUser}
    /> }
    </>
  )
}

export default InitialCYOAPrompt